import { z } from 'zod';

export namespace Auth {
  export const Token = z.string().brand('AuthToken');
  export type Token = z.infer<typeof Token>;
}
